import React from 'react';
import $ from '../../common/AjaxRequest';
import { Modal, Checkbox, message } from 'antd';
import API_URL from '../../common/url';
import './style/list.less';

class ConfigColumn extends React.Component {
    state = {
        params: {},
        columns: [],
        visible: false,
    }

    show = (params, columns) => {
        const array = [];
        const { typeName } = this.props;
        columns.forEach(column => {
            const params = { ...column };
            if (column.moduleDefineName === '录入者') {
                params.isShow = 1;
            }
            if (column.moduleDefineName !== '操作') {
                array.push(params);
            }
        });
        if(typeName == 'Type_Visit') {
            const newArray = [];
            array.forEach((i) => {
                newArray.some((item) => item.moduleDefineCode == i.moduleDefineCode) ? '' : newArray.push(i);
            });
            this.setState({
                visible: true,
                columns: newArray,
                params: {...params},
            });
        } else {
            this.setState({
                visible: true,
                columns: array,
                params: {...params},
            });
        }
    }

    hide = () => {
        this.setState({
            data: [],
            visible: false,
        });
    }

    handleSubmit = () => {
        const { typeName } = this.props;
        const { params, columns } = this.state;
        this.setState({ confirmLoading: true });
        
        let moduleDefineCodes = '';
        columns.forEach(column => {
            const { isShow, moduleDefineCode } = column;
            if (isShow) {
                moduleDefineCodes += `,${moduleDefineCode}`;
            }
        });

        moduleDefineCodes = moduleDefineCodes && moduleDefineCodes.substring(1);

        const options = {
            method: 'POST',
            url: API_URL.execute.saveVisitTypeCustomizeColumn,
            data: {
                typeName,
                ...params,
                moduleDefineCodes,
            },
            dataType: 'json',
            doneResult: () => {
                message.success('保存成功');
                this.setState({
                    visible: false,
                    confirmLoading: false
                });
                this.props.loadData();
            },
            errorResult: () => {
                this.setState({ confirmLoading: false });
            },
        }
        $.sendRequest(options)
    }

    onCheckChange = (e, index) => {
        const { columns } = this.state;
        columns[index].isShow = e.target.checked ? 1 : 0;
        this.setState({ columns });
    }

    render() {
        const { typeName } = this.props;
        const { visible, confirmLoading, columns } = this.state;
        return (
            <Modal
                title="自定义显示列"
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                className="condition-modal"
                wrapClassName="vertical-center-modal"
                width="520px"
                confirmLoading={confirmLoading}
            >
                <div className="con-options config_column">
                    <div>
                        {
                            columns.map((value, index) => {
                                const { isShow, moduleDefineName, visitTypeNameShow, moduleDefineCode } = value;
                                const newModuleDefineName = visitTypeNameShow ? `${visitTypeNameShow},${moduleDefineName}` : moduleDefineName;
                                const name = newModuleDefineName.split(',').filter(i => !!i).join('/');
                                if ((typeName == 'Type_Filter' || typeName == 'Type_Visit') && (moduleDefineName === "筛选编号" || moduleDefineName === "录入者" )) {
                                    return (
                                        <div key={moduleDefineCode} className="SetCheckbox">
                                            <Checkbox
                                                disabled
                                                checked={isShow === 1}
                                                onChange={(e) => this.onCheckChange(e, index)}
                                            >
                                                <span title={name}>{name}</span>
                                            </Checkbox>
                                        </div>
                                    )
                                } else {
                                    return (
                                        <div key={moduleDefineCode} className="SetCheckbox">
                                            <Checkbox
                                                checked={isShow === 1}
                                                onChange={(e) => this.onCheckChange(e, index)}
                                            >
                                                <span title={name}>{name}</span>
                                            </Checkbox>
                                        </div>
                                    )
                                }
                            })
                        }
                    </div>
                </div>
            </Modal>
        );
    }
}

export default ConfigColumn;



// WEBPACK FOOTER //
// ./src/components/execute/ConfigColumn.js